import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import { SuccessDialogTemplateComponent } from './components/dialog-template/success-dialog-template/success-dialog-template.component';
import { ApiErrorDialogTemplateComponent } from './components/dialog-template/api-error-dialog-template/api-error-dialog-template.component';
import { ConfirmDialogTemplateComponent } from './components/dialog-template/confirm-dialog-template/confirm-dialog-template.component';

@NgModule({
  declarations: [SuccessDialogTemplateComponent, ApiErrorDialogTemplateComponent, ConfirmDialogTemplateComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule
  ],
  exports:[
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    SuccessDialogTemplateComponent,
    ApiErrorDialogTemplateComponent,
    ConfirmDialogTemplateComponent
  ]
})
export class SharedModule { }
